import React, { useRef } from 'react'
import { Box, Card, Grid, Grow, IconButton, Typography } from '@material-ui/core'
import { UploadIcon } from 'asterX-UI/Icons/UploadIcon'
import { FileIcon } from 'asterX-UI/Icons/FileIcon'
import { BlueLines } from 'asterX-UI/Icons/BlueLines'
import { DeleteIcon } from 'asterX-UI/Icons/DeleteIcon'
import {
  BorderLinearProgress
} from '../../../pages/ContractPage/components/FileContract/components/UploadFilesModal/const'
import { useStyles } from '../add-deferral.styles'

const fileToBase64 = (file, onProgress) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onprogress = e => {
      if (e.lengthComputable && typeof onProgress === 'function') {
        const p = Math.round((e.loaded / e.total) * 100)
        onProgress(p)
      }
    }
    reader.onload = () => {
      const res = reader.result || ''
      const base64 = typeof res === 'string' ? res.split(',')[1] : ''
      resolve(base64)
    }
    reader.onerror = reject
    reader.readAsDataURL(file)
  })

const FileUploadCardInline = ({ label, subtitle, file, path, onFileChange, onDelete, error = false }) => {
  const classes = useStyles()
  const inputRef = useRef(null)

  const handlePick = () => inputRef.current?.click()

  const handleUpload = async e => {
    const f = e.target.files?.[0]
    if (!f) return

    const uploadedBase = {
      name: f.name,
      size: f.size,
      date: new Date().toLocaleDateString(),
      progress: 0,
      base64: null,
      raw: f
    }

    // Показать карточку сразу с 0%
    onFileChange(path, uploadedBase)

    // Обновлять прогресс, пока FileReader читает файл
    const base64 = await fileToBase64(f, p => {
      onFileChange(path, { ...uploadedBase, progress: p })
    })

    // Завершить: 100% и готовый base64
    onFileChange(path, { ...uploadedBase, base64, progress: 100 })

    // Сброс input, чтобы можно было выбрать тот же файл ещё раз
    e.target.value = null
  }

  return (
    <>
      <Card variant="outlined" className={classes.card} style={error ? { borderColor: '#f44336' } : undefined}>
        <IconButton className={classes.icon} component="label">
          <UploadIcon />
          <input type="file" hidden ref={inputRef} onChange={handleUpload} />
        </IconButton>
        <Grid item className={classes.textWrapper} onClick={handlePick}>
          <Typography className={classes.title}>{label}</Typography>
          <Typography className={classes.subtitle}>{subtitle || 'или перетащите документ в эту область'}</Typography>
        </Grid>
      </Card>

      {file && (
        <Grow in timeout={500}>
          <Grid item container className={classes.fileContainer}>
            <Grid item className={classes.fileIcon}>
              <FileIcon />
              <Box className={classes.blueLines}>
                <BlueLines />
              </Box>
            </Grid>
            <Grid item xs={10}>
              <Grid item className={classes.fileWrapper}>
                <Grid item>
                  <Typography variant="body2" className={classes.label}>
                    {file.name}
                  </Typography>
                  <Typography variant="body2" className={classes.date}>
                    {file.date}
                  </Typography>
                </Grid>
                <IconButton onClick={() => onDelete(path)}>
                  <DeleteIcon />
                </IconButton>
              </Grid>
              <Box display="flex" alignItems="center" style={{ gap: 8 }}>
                <Box width="100%" mr={1}>
                  <BorderLinearProgress variant="determinate" value={file?.progress ?? 0} />
                </Box>
                <Box minWidth={35}>
                  <Typography variant="body2">{`${Math.round(file?.progress ?? 0)}%`}</Typography>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Grow>
      )}
    </>
  )
}

export default FileUploadCardInline
